import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import {
  ListDisplay,
  ContentDisplay,
  Heading,
  BaseText,
  ButtonIconContextual
} from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IAbout, IAboutRow } from '@/modules/catalog/services/variable-income';
import { DynamicContentModal } from '@/modules/common/components/DynamicContentModal';
import { IDynamicContent } from '@/modules/common/types';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';

interface Props {
  about: IAbout;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  props: {
    about: null
  },
  setup(__props: any) {

const props = __props as {
  about: IAbout;
};


const isDetailModalOpen = ref(false);
const modalTitle = ref('');
const modalInfo = ref<IDynamicContent[]>([]);

const toggleDetailModal = (row: IAboutRow) => {
  if (row) {
    modalTitle.value = row.label;
    modalInfo.value = row.content || [];
  }
  isDetailModalOpen.value = !isDetailModalOpen.value;
};

const title = computed(() => {
  return props.about?.title || '-';
});

const riskColor = computed(() => {
  return NebraskaColors.riskHigh;
});

const riskProfileButtonLabel = computed(() => {
  return props.about.riskProfile?.buttonLabel || 'Perfil';
});

const riskProfileTitle = computed(() => {
  return props.about.riskProfile?.portfolioRiskProfile.formatted || '';
});

const riskProfileDescription = computed(() => {
  return props.about.riskProfile?.portfolioRiskProfile.description || '';
});

const riskProfileHref = computed(() => {
  const { domain } = getDomainAndPlatform();

  return `/onboarding/${domain}/desktop/suitability/user-profile`;
});

return { __sfc: true,props, isDetailModalOpen, modalTitle, modalInfo, toggleDetailModal, title, riskColor, riskProfileButtonLabel, riskProfileTitle, riskProfileDescription, riskProfileHref, ListDisplay, ContentDisplay, Heading, BaseText, ButtonIconContextual, NebraskaColors, DynamicContentModal }
}

})